<div class="container-fluid centered">
    <div class="row">
        <div class="row justify-content-md-center">
            <div class="col-sm-8">
                <div class="card tab2-card ">
                    <div class="card-body tab2-card">
                        <div class="form-group row">
                            <img class="responsive" src="../../../../assets/images/homepage-logo.png" alt="">
                        </div>
                        <div class="form-group row">
                            <img class="responsive" src="../../../../assets/images/homepage-data-lansare.png" alt="">
                        </div>
                        <div class="form-group row">
                            <label class="bold">{{homepageTitle}}</label>
                        </div>
                        <div class="form-group row">
                            <label>{{homepageText}}</label>
                        </div>
                        <div class="form-group row justify-content-md-center">
                            <div class="center-item">
                                <div placement="bottom" class="d-inline-block dropdown">
                                    <button class="btn btn-primary responsiveButton" type="button"
                                        id="dropdownMenuButton" aria-expanded="false" [routerLink]="['/comparator']"
                                        [queryParams]="{comparatorType: 'gas'}">
                                        {{naturalGasSupplyComparison}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row justify-content-md-center">
                            <div class="center-item">
                                <div placement="bottom" class="d-inline-block dropdown">
                                    <button class="btn btn-primary responsiveButton" type="button"
                                        id="dropdownMenuButton" aria-expanded="false" [routerLink]="['/comparator']"
                                        [queryParams]="{comparatorType: 'electric'}">
                                        {{naturalElectricitySupplyComparison}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row justify-content-md-center">
                            <div class="col-xs">
                                <img class="responsive" src="../../../../assets/images/right-arrow.png" alt="">
                            </div>
                            <div class="col-xs d-flex justify-content-center">
                                <div class="supplier-change d-flex justify-content-center"
                                    [routerLink]="['/utilizator']">
                                    Schimba furnizorul
                                </div>
                            </div>
                        </div>
                        <div class="card-header">
                            <img class="responsive" src="../../../../assets/images/homepage-footer.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>